module.exports = __webpack_public_path__ + "static/media/logo_AjT_ALT_marro.299a733b.png";